import styled from 'styled-components';
import Button from '/imports/ui/components/common/button/component';
import {
  colorWhite,
  colorBlack,
  colorTransparent,
  colorPrimary,
} from '/imports/ui/stylesheets/styled-components/palette';

const DownloadButton = styled(Button)`
  &,
  &:active,
  &:hover,
  &:focus {
    background-color: ${colorPrimary} !important;
    border: none !important;

    i {
      border: none !important;
      background-color: ${colorPrimary} !important;
    }
  }

  font-size : 14px;
  padding: 5px 10px;
  border-radius : 8px;
  ${'' /* color : ${colorWhite}; */}
  &:hover {
    border: 0;
  }

  i {
    font-size: 1rem;
  }
`;

const ButtonWrapper = styled.div`
  position: absolute;
  left: auto;
  right: 10px;
  background-color: ${colorTransparent};
  cursor: pointer;
  border: 0;
  z-index: 999;
  margin: 2px;
  bottom: 0;
  border-radius : 8px;

  [dir="rtl"] & {
    right: 0;
    left : auto;
  }

  [class*="presentationZoomControls"] & {
    position: relative !important;
  }

  ${({ theme }) => theme === 'dark' && `
    background-color: rgba(0,0,0,.3) !important;

    & > button i {
      color: ${colorWhite} !important;
    }
  `}

  ${({ theme }) => theme === 'light' && `
    background-color: ${colorTransparent} !important;

    & > button i {
      color: ${colorBlack} !important;
    }
  `}
`;

export default {
  DownloadButton,
  ButtonWrapper,
};
